export const drawrContext = {
  LEAD_CONNECTOR: "Managed by LeadConnector",
  TWILIO: "Managed by Twilio",
  INITIAL: "Setup Twilio for sub-account",
};

export const table = {
  SIZE: 15,
  OFFSET: 15,
};

export const twilioLoginModal = {
  AGENCY: "agency",
  SUB_ACCOUNT: "sub-account",
};

export const tableFilter = {
  MANAGED_BY: "managed-by",
  PHONE_REBILLING: "phone-rebilling",
  NUMBER_VALIDATION: "number-validation",
  SMS_CAPABILITIES: "sms-capabilities",
  ALL: "all",
  NONE: "none",
  LC_PHONE: "lc-phone",
  TWILIO: "twilio",
  ENABLED: "enabled",
  DISABLED: "disabled",
  ACTIVE: "active",
  RESTRCITED: "restricted",
};

export const moveNumberStatus = {
  NO_NUMBERS: "No phone numbers in this account",
};

export const enum LCPhoneState {
  ENABLED = 'enabled',
  MIGRATION_IN_PROCESS = 'migration_in_process',
  NOT_ENABLED = 'not_enabled'
}